import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import { ROUTES } from 'shared/routes/constants';
import ErrorUI from 'uicontainers/apps/survey/Error';
import ErrorRefreshed from 'uicontainers/apps/survey_refresh/Error';

export const Error = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const template = queryParams.get('survey_template');
  return (
    <>
      <Switch>
        <Route
          path={ROUTES.SURVEY.PATHS.ERROR}
          component={template === 'SURVEY_2025' ? ErrorRefreshed : ErrorUI}
        />
      </Switch>
    </>
  );
};

export default Error;
